import React from "react";
import { Carousel } from "react-bootstrap";
import { useAppContext } from "../../context";

const Slider = ({
  controls,
  indicators,
  interval,
  onSelect,
  children,
  touch,
}) => {
  const { state } = useAppContext();
  return (
    <Carousel
      controls={controls}
      indicators={indicators}
      activeIndex={state.index}
      onSelect={onSelect}
      interval={interval}
      touch={touch}
    >
      {children}
    </Carousel>
  );
};

export default Slider;
